import { Tooltip } from "@mui/material";

export const MuiTooltip = Tooltip;
